import axios from 'axios';
import { configRefs } from '@utils/constants';

async function updateTeamRequest(user, team) {
  if (!user) {
    throw new Error("updateTeamRequest(): A logged in user must be provided when updating teams!");
  }
  const teamDTO = {
    userID: user.id,
    userInstitutionID: user.institution?.id,
    enableNotifications: team.enabledNotifications,
    title: team.title,
    subjects: team.subjects,
    teams: team.teams
  };
  await axios.put(`${await configRefs.apis.userdata.get()}/api/Filters/${team.id}`, teamDTO);
  return {
    ...team,
    modifiedAt: new Date()
  };
}

export { updateTeamRequest };
//# sourceMappingURL=api.update-team.request.js.map
